import { c as _c } from "react/compiler-runtime";
import { formatPrice, TextPassage } from '@petsmart-ui/sparky';
type CountdownTitleProps = {
  readonly amountAway: number;
  readonly isLoggedIn: boolean;
};
export const CountdownTitle = t0 => {
  const $ = _c(6);
  const {
    amountAway,
    isLoggedIn
  } = t0;
  if (amountAway === 0) {
    let t1;
    if ($[0] !== isLoggedIn) {
      t1 = <TextPassage className="countdown-card__title sparky-u-margin-left-xs" data-testid="countdown-title" role="heading" aria-level={3}>{isLoggedIn ? <>You're getting <strong>FREE shipping!</strong></> : <>Don't miss out on <strong>FREE shipping!</strong></>}</TextPassage>;
      $[0] = isLoggedIn;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== amountAway) {
    t1 = formatPrice(amountAway);
    $[2] = amountAway;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <TextPassage className="countdown-card__title sparky-u-margin-left-xs" data-testid="countdown-title" role="heading" aria-level={3}><><strong>{t1}</strong> away from FREE shipping</></TextPassage>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};